<template>
	<v-card class="w-75 " style="background-color: rgba(255, 255, 255, 0.4);" variant="elevated">
		<v-card-text>

			<v-container class="pb-0">
				<v-row justify="space-between">
					<div>
						<v-icon v-if="mission.active_mission" icon="mdi-antenna"></v-icon>
						<strong :style="'color:' + mission.vehicles[0].boat_mark_color ?? 'default'">{{ mission.name
						}}</strong>
					</div>


					<p>{{ new
						Date(mission.current_playing_date).toLocaleString()
					}}</p>




				</v-row>
				<v-row>
					<v-slider :disable="mission.is_loading" class="bar" :min="0" :max="mission.total_intervals" step="1"
						@end="endSlider($event)" @start="startSlider()" track-size="10" v-model="T"
						:color="mission.vehicles[0].boat_mark_color ?? 'default'" hide-details width="100%">
						<template v-slot:append v-if="mission.active_mission">
							<v-icon :color="liveFollow ? 'red' : 'grey'" :class="{ 'opacity-100': liveFollow }"
								icon="mdi-circle" @click="goLiveTime($event)" size="small"></v-icon>
						</template>
					</v-slider>
					<!-- <input type="range" :disable="mission.is_loading" :min="0" :max="mission.total_intervals" step="1"
						v-model="T"> -->
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions class="pt-0">
			<v-container class="pa-0">
				<v-row justify="space-evenly" align="center">
					<v-col>
						<v-btn variant="text" :icon="!mission.current_playing ? 'mdi-play' : 'mdi-pause'"
							@click="playAndPause()"></v-btn>
					</v-col>

					<v-col>
						<v-btn variant="text" @click="close()" icon="mdi-close"></v-btn>
					</v-col>

					<v-col>

						<v-btn style="font-weight: bold; height: 100%; width: 32px; font-size: large;">
							{{ speed + 'X' }}
							<v-menu activator="parent" transition="slide-x-transition" location="end">
								<v-list>
									<v-list-item variant="plain"
										v-for="(item, index) in speedOptions.filter(option => option !== speed)"
										:key="index" @click="speed = item">
										<v-list-item-title> <span style="font-weight: bold;">{{ item + 'X' }}</span>
										</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-btn>

					</v-col>

					<v-col v-if="Object.keys(missionToFollow).length == 0">
						<v-btn icon="mdi-crosshairs" id="menu-activator">
						</v-btn>
						<v-menu activator="#menu-activator">
							<v-list density="compact" slim>
								<v-list density="compact" slim>
									<template v-for="(vehicle, index) in mission.vehicles" :key="vehicle.id">
										<v-list-item variant="plain">
											<v-list-item-title class="text-center mb-2">
												<span style="font-weight: bold">{{ vehicle.name }}</span>
											</v-list-item-title>

											<v-list-item-action class="mb-3">
												<v-row>
													<v-list-item variant="plain"
														@click="goToMissionPosition(vehicle.id)">
														<v-list-item-title>
															<span style="font-weight: bold">Center</span>
														</v-list-item-title>
													</v-list-item>

													<v-list-item variant="plain"
														@click="followMissionPosition(true, vehicle.id)">
														<v-list-item-title>
															<span style="font-weight: bold">Follow</span>
														</v-list-item-title>
													</v-list-item>
												</v-row>
											</v-list-item-action>
										</v-list-item>
										<v-divider v-if="index < mission.vehicles.length - 1" />
									</template>
								</v-list>

							</v-list>
						</v-menu>
					</v-col>

					<v-col v-else-if="missionToFollow.id == mission.id">
						<v-icon size="large" @click="followMissionPosition(false)"
							color="info">mdi-crosshairs-gps</v-icon>
					</v-col>

					<v-col>


						<v-menu v-model="sizeIconMenu" :close-on-content-click="false">
							<template v-slot:activator="{ props }">
								<v-btn icon="mdi-resize" v-bind="props" />
							</template>
							<v-list density="compact" slim>
								<template v-for="(vehicle, index) in mission.vehicles" :key="vehicle.id">
									<v-list-item variant="plain">
										<v-list-item-title class="text-center mb-2">
											<span style="font-weight: bold">{{ vehicle.name }}</span>
										</v-list-item-title>

										<v-list-item-action class="mb-3">
											<v-row justify="space-between" class="px-4" align="center"
												style="width: 100%;">
												<v-btn size="small" variant="text" icon="mdi-minus"
													@click="() => { if (vehicle.size > 10) vehicle.size -= 10 }" />
												<span class="mx-2 font-weight-bold">{{ vehicle.size }}</span>
												<v-btn size="small" variant="text" icon="mdi-plus"
													@click="() => { if (vehicle.size < 100) vehicle.size += 10 }" />
											</v-row>
										</v-list-item-action>

									</v-list-item>
									<v-divider v-if="index < mission.vehicles.length - 1" />
								</template>
							</v-list>
						</v-menu>

					</v-col>
				</v-row>
			</v-container>
		</v-card-actions>


	</v-card>

</template>

<script setup>
import { onBeforeMount, watch, ref, onUnmounted, onErrorCaptured, computed, onMounted } from 'vue';
import { usePlayMissionStore } from '@/store/playMission'
import { storeToRefs } from 'pinia';

const props = defineProps({ 'mission_id': Number });
const emits = defineEmits(['close', 'goToMissionPosition', 'changing_data'])

const playMissionStore = usePlayMissionStore();
const { missionToFollow } = storeToRefs(playMissionStore);

const sizeIconMenu = ref(false);


const mission = computed(() => playMissionStore.missions.find(m => m.id === props.mission_id));
const total_intervals = computed(() => mission.value.total_intervals);

const speed = ref(1);
const speedOptions = ref([1, 2, 4, 8, 16, 32, 64]);
let interval = null;
const T = ref(0);
const uiStop = ref(false);
const liveFollow = ref(true);



const advancePlaybackTime = async () => {
	if (mission.value.is_loading) return;
	if (T.value < mission.value.total_intervals) {
		T.value += 1;
	} else {
		if (!mission.value.active_mission) {
			clearInterval(interval);
			interval = null;
			//mission.value.current_playing = false;
		} else {
			liveFollow.value = true;
		}

	}
};

watch(total_intervals, (value, oldValue) => {
	if (liveFollow.value && mission.value.current_playing) {
		T.value = total_intervals.value;
	} else {
		liveFollow.value = false;
	}
})

const endSlider = async (number) => {
	for (const vehicle of mission.value.vehicles) {
		if (
			(vehicle.meta.window_start > mission.value.current_playing_date) ||
			(vehicle.meta.window_end < mission.value.current_playing_date && !vehicle.meta.end)
		) {
			await changePage(vehicle.id, mission.value.current_playing_date);
		}
	}

	if (T.value == total_intervals.value) {
		liveFollow.value = true;
	} else {
		liveFollow.value = false;
	}

	uiStop.value = false;
	clearInterval(interval);
	interval = null;
	addInterval();
}

const startSlider = () => {
	clearInterval(interval);
	interval = null;
	liveFollow.value = false;
	uiStop.value = true;
}

const addInterval = () => {
	if (!mission.value.current_playing) return
	if (interval) clearInterval(interval);
	let ficticialSpeed = speed.value >= 16 ? 8 : speed.value;
	const delay = Math.max(100, 1000 / ficticialSpeed); // evitar intervalos demasiado rápidos
	interval = setInterval(advancePlaybackTime, delay);
}

const findClosestIndex = (timestamps, time) => {
	let low = 0;
	let high = timestamps.length - 1;

	while (low <= high) {
		const mid = Math.floor((low + high) / 2);
		if (timestamps[mid] === time) return mid;
		if (timestamps[mid] < time) low = mid + 1;
		else high = mid - 1;
	}

	return Math.max(0, low - 1); // el más cercano anterior o igual
}

const goLiveTime = () => {
	if (!liveFollow.value) liveFollow.value = true;
	if (liveFollow.value) {
		clearInterval(interval);
		interval = null;

		//liveFollow.value = false;
		T.value = total_intervals.value;
	}

}

watch(T, async () => {
	const offset = T.value * mission.value.interval * 1000;

	mission.value.current_playing_date = mission.value.start_time_ms + offset;

	for (const vehicle of mission.value.vehicles) {
		const currentTime = mission.value.current_playing_date;

		vehicle.P = findClosestIndex(vehicle.timestamps, currentTime);



		if (!uiStop.value) {
			if (currentTime >= vehicle.meta.window_end && !vehicle.meta.end) {
				await changePage(vehicle.id, currentTime);
			}
		}
	}
});


const changePage = async (vehicle_id, currentTime) => {
	clearInterval(interval);
	interval = null;
	uiStop.value = true;
	mission.value.is_loading = true;
	emits('changing_data', true);
	await usePlayMissionStore().nextPage(
		mission.value.id,
		vehicle_id,
		currentTime,
		mission.value.recordsType,
		mission.value.interval
	)
	let index = mission.value.vehicles.findIndex((v) => v.id == vehicle_id);

	mission.value.vehicles[index].P = findClosestIndex(mission.value.vehicles[index].timestamps, currentTime);

	mission.value.is_loading = false;
	uiStop.value = false;
	emits('changing_data', false);
	if (mission.value.current_playing) addInterval()
}




const close = async () => {
	try {
		clearInterval(interval);
		interval = null;
		if (playMissionStore.missionToFollow?.id == mission.value.id) {
			await playMissionStore.followMissionPosition({});
			console.log("Borrado de follow mission");
		}
		if (mission.value) {
			mission.value.is_loading = true;
			const missionToSend = JSON.parse(JSON.stringify(mission.value));
			emits('close', missionToSend);
		} else {
			console.warn('No mission to emit during close');
		}
	} catch (err) {
		console.error("Error during close():", err);
	}
};

const goToMissionPosition = (vehicle_id) => {
	emits('goToMissionPosition', mission.value, vehicle_id);
}

const followMissionPosition = (activate, vehicle_id) => {
	if (activate) {
		playMissionStore.followMissionPosition(mission.value, vehicle_id);
	} else {
		playMissionStore.followMissionPosition({});
	}
}

onMounted(() => {
	mission.value.is_loading = false;
	if (mission.value.active_mission) {
		T.value = mission.value.total_intervals;
	}
});

onUnmounted(() => {
	playMissionStore.followMissionPosition({});
	clearInterval(interval);
	interval = null;
	emits("changing_data", false)

})

const playAndPause = () => {
	mission.value.current_playing = !mission.value.current_playing;
	clearInterval(interval);
	interval = null;

	if (mission.value.current_playing) {
		addInterval();
	}
}


watch(speed, () => {
	clearInterval(interval);
	interval = null;
	addInterval()
});
</script>

<style lang="css">
.opacity-100 {
	opacity: 100 !important;
}
</style>